import { useState } from "react";
import { fetchRelativeLessonsDetails } from "../services/chatbotService";
import { handleDownloadFullChat } from "../services/chatbotDownloadHelper";

export const useChatbotDownload = () => {
  const [downloadModalOpen, setDownloadModalOpen] = useState(false);
  const [downloadFormatOption, setDownloadFormatOption] = useState("html");
  const [downloadExplanationOption, setDownloadExplanationOption] = useState(true);
  const [downloadChatOption, setDownloadChatOption] = useState(true);
  const [downloadQuestionsOption, setDownloadQuestionsOption] = useState(true);
  const [downloadRelativeLessonsOption, setDownloadRelativeLessonsOption] = useState(true);
  const [downloadSolvedOption, setDownloadSolvedOption] = useState(true);
  const [downloadStudentAnswersOption, setDownloadStudentAnswersOption] = useState(true);
  const [downloadHintsOption, setDownloadHintsOption] = useState(true);
  const [isDownloading, setIsDownloading] = useState(false);

  const performDownload = async ({
    messages,
    activeSessionId,
    history,
    user,
    t,
    activeQuestions,
    solvedQuestions,
    examAnswers,
    FontSize,
    relativeLessonsDetails,
  }) => {
    if (isDownloading) return;
    setIsDownloading(true);
    try {
      let logoBase64 = null;
      try {
        const response = await fetch("/assets/images/logo/logo.png");
        const blob = await response.blob();
        logoBase64 = await new Promise((resolve) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result);
          reader.readAsDataURL(blob);
        });
      } catch (e) {
        console.error("Failed to fetch logo as base64:", e);
      }

      let lessonId = null;
      if (activeQuestions && activeQuestions.length > 0) {
        const found = activeQuestions.find((q) => q.lessonId || q.LessonId);
        if (found) {
          lessonId = found.lessonId || found.LessonId;
        }
      }
      if (!lessonId && relativeLessonsDetails && relativeLessonsDetails.length > 0) {
        const firstLesson = relativeLessonsDetails.find((d) => d.Type !== "File");
        if (firstLesson) {
          lessonId = firstLesson.Id || firstLesson.id;
        }
      }

      let currentLessonInfo = null;
      if (lessonId) {
        try {
          const details = await fetchRelativeLessonsDetails([{ Id: lessonId }]);
          if (details && details.length > 0) {
            const l = details[0];
            let href = l.Link || l.Url || l.href || l.link || "";
            if (!href) {
              const type = l.Type || l.type || "";
              const urlPrefix = type === "Game" ? "GameView" : (type === "Exam" ? "ExamView" : "LessonView");
              href = `/${urlPrefix}/${l.Id || l.id}`;
            }
            currentLessonInfo = {
              name: l.Name || l.Text || l.text || l.name || "",
              link: href,
            };
          }
        } catch (err) {
          console.error("Failed to fetch current lesson details:", err);
        }
      }

      handleDownloadFullChat({
        messages,
        activeSessionId,
        history,
        downloadFormat: downloadFormatOption,
        downloadExplanation: downloadExplanationOption,
        downloadChat: downloadChatOption,
        downloadQuestions: downloadQuestionsOption,
        downloadRelativeLessons: downloadRelativeLessonsOption,
        downloadSolved: downloadSolvedOption,
        downloadStudentAnswers: downloadStudentAnswersOption,
        downloadHints: downloadHintsOption,
        FontSize,
        logoBase64,
        user,
        activeQuestions,
        solvedQuestions,
        examAnswers,
        t,
        currentLessonInfo,
        relativeLessons: relativeLessonsDetails || [],
      });
    } catch (err) {
      console.error("Failed to perform download:", err);
    } finally {
      setIsDownloading(false);
      setDownloadModalOpen(false);
    }
  };

  return {
    downloadModalOpen,
    setDownloadModalOpen,
    downloadFormatOption,
    setDownloadFormatOption,
    downloadExplanationOption,
    setDownloadExplanationOption,
    downloadChatOption,
    setDownloadChatOption,
    downloadQuestionsOption,
    setDownloadQuestionsOption,
    downloadRelativeLessonsOption,
    setDownloadRelativeLessonsOption,
    downloadSolvedOption,
    setDownloadSolvedOption,
    downloadStudentAnswersOption,
    setDownloadStudentAnswersOption,
    downloadHintsOption,
    setDownloadHintsOption,
    isDownloading,
    performDownload,
  };
};
